export default __webpack_public_path__ + "static/9-tips-to-avoid-jet-lag-hero-image-dc120e5562c9174838973fbb44811d2b.jpg";